import { status } from 'src/colors';
import { IssueState } from '../../types/issue-state';

export const issueStateColors: Record<IssueState, string> = {
  NEW: status.info,
  IN_PROGRESS: status.pending,
  RESOLVED: status.success,
  REJECTED: status.error,
};
